import { styled } from '@olxeu-jobs/ui';
import { ResponsiveImage } from '~features/fapollo';

export const MAX_WIDTH = 96;

export const Wrapper = styled('div', ({ $theme }) => ({
  display: 'flex',
  overflow: 'hidden',
  borderRadius: $theme.radii[4],
  width: '100%',
  height: '100%',
  maxWidth: `${MAX_WIDTH - 32}px`,
  maxHeight: `${MAX_WIDTH - 32}px`,
  [$theme.mediaQuery.sm]: {
    maxWidth: `${MAX_WIDTH - 16}px`,
    maxHeight: `${MAX_WIDTH - 16}px`,
  },
  [$theme.mediaQuery.md]: {
    maxWidth: `${MAX_WIDTH}px`,
    maxHeight: `${MAX_WIDTH}px`,
  },
}));

export const ResponsiveLogoImage = styled(ResponsiveImage, {
  display: 'flex',
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});
